import { HUBLESS_ROOT_URL } from './urls';
export default function isHubless() {
  // eslint-disable-next-line no-restricted-syntax
  return window.location.href.includes(HUBLESS_ROOT_URL);
}